// extracted by mini-css-extract-plugin
export default {"container":"PathInfo_container__aY9D8","icon":"PathInfo_icon__9rKqC","popoverPrimary":"PathInfo_popoverPrimary__LDhbn","popoverSecondary":"PathInfo_popoverSecondary__MsBSO"};